function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createUseStyles } from 'react-jss';
var useMobileDrawerTriggerStyles = createUseStyles(function (_ref) {
  var breakpoints = _ref.breakpoints,
    palette = _ref.palette;
  return {
    MobileTrigger: {
      float: 'left',
      '&.sm-mobile-menu__cta [class^="wrenchButton"]': _defineProperty({
        border: 0,
        width: 20,
        height: 50,
        fontSize: 20,
        cursor: 'pointer',
        boxSizing: 'content-box',
        outline: 0,
        order: 3,
        position: 'absolute',
        left: 0,
        color: palette.text.light
      }, "@media (min-width: ".concat(breakpoints.xl, "px)"), {
        display: 'none'
      }),
      '&.sm-mobile-menu--alt [class^="wrenchButton"]': {
        color: palette.text.light,
        '&:hover, &:focus': {
          background: 'transparent'
        }
      },
      '&.sm-mobile-menu__cta.sm-mobile-menu--secondary [class^="wrenchButton"]': {
        color: palette.primary.main,
        '&:hover, &:focus': {
          background: palette.background.main
        }
      }
    }
  };
});
export default useMobileDrawerTriggerStyles;
//# sourceMappingURL=useMobileDrawerTriggerStyles.js.map